import { MDText } from 'i18n-react';

import type { VehicleState } from 'Pages/vehicles/helpers/vehicle.schema';

import { TextCTA } from '../../TextCTA/TextCTA';
import texts from '../BiddingSectionCTAStateController.texts';
import { getSaleType } from '../getSaleType';

const LocalT = new MDText(texts.otherContactHasBidOrOffered);

export const OtherContactHasBidOrOffered: React.FC<{ state: VehicleState }> = ({ state }) => {
	const saleType = getSaleType(state);

	return (
		<TextCTA description={LocalT.translate(`description.${saleType}`)} title={LocalT.translate(`title.${saleType}`)} />
	);
};
